// INGRESSO IN PARTITA, LATO CLIENT
//
// Il client non dichiara piu' il proprio tier: lo chiede al server, che addebita
// l'entry fee (oggi zero, in fase di test) ed emette un ticket monouso. Il
// ticket e' l'unica cosa che serve poi al `join_game`.
//
// In fase di test tutto questo non costa niente all'utente: nessun popup del
// wallet, nessun saldo che scende. Il percorso viene comunque eseguito per
// intero, cosi' il giorno in cui i prezzi si accendono non c'e' codice nuovo
// da provare.

import { authHeader } from './authClient';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Chiede il ticket per un tier. Ritorna { ticketId, tier, price, expiresAt }.
export async function requestEntryTicket(wallet, tier) {
  const res = await fetch(`${API_BASE}/api/entry`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader(wallet) },
    body: JSON.stringify({ tier }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || 'Ingresso rifiutato dal server');
    err.code = data.code;
    throw err;
  }
  return data;
}

// Prezzi correnti e profilo attivo, per mostrare in lobby quanto costa entrare
// invece di riscrivere i numeri nel client.
export async function fetchPricing() {
  const res = await fetch(`${API_BASE}/api/pricing`);
  if (!res.ok) throw new Error('Prezzi non disponibili');
  return res.json();
}
